import { TwoStepPaymentFormStepButton } from 'common/components/entities/two-step-payment-form'
import { TwoStepPaymentFormStepButtonProps } from 'common/components/entities/two-step-payment-form/two-step-payment-form-step-button'
import { BookingPaidCalendarInterface } from 'common/types/entities/booking-paid-calendar-interface'
import { OldEntityInterface } from 'common/types/entities/OldEntityInterface'
import { PaymentButtonInterface } from 'common/types/entities/PaymentButtonInterface'
import { TwoStepPaymentFormStepInterface } from 'common/types/entities/two-step-payment-form-interface'
import FieldErrors from 'publisher/components/FieldErrors'
import useManagement from 'publisher/hooks/useManagement'
import ThreeDsModal, {
  ThreeDsInfo,
} from 'publisher/paymentProcessors/mercadoPago/components/ThreeDsModal'
import managementSelectors from 'publisher/store/management/managementSelectors'
import React, { useCallback, useState } from 'react'

export interface TwoStepCommonPaymentButtonProps
  extends TwoStepPaymentFormStepButtonProps {
  entity: TwoStepPaymentFormStepInterface
  isMercadoPagoCardMethod: boolean
  paymentHandler: (
    entity:
      | OldEntityInterface
      | PaymentButtonInterface
      | BookingPaidCalendarInterface
      | TwoStepPaymentFormStepInterface,
  ) => {
    isLoading: boolean
    // biome-ignore lint/suspicious/noExplicitAny: any arguments typing is intentional
    handleSubmit: (...args: any) => Promise<void> | void
    errors: string[]
    setErrors?: (errors: string[]) => void
  }
}

export const TwoStepCommonPaymentButton = ({
  entity,
  color,
  mobileColor,
  backgroundColor,
  mobileBackgroundColor,
  text,
  subText,
  paymentHandler,
  isMercadoPagoCardMethod,
}: TwoStepCommonPaymentButtonProps) => {
  const { isLoading, handleSubmit, errors, setErrors } = paymentHandler(entity)
  const isPreview = useManagement(managementSelectors.isPreview)
  const [threeDsInfo, setThreeDsInfo] = useState<ThreeDsInfo>({
    creq: '',
    external_resource_url: '',
  })
  const [isThreeDsModalOpen, setIsThreeDsModalOpen] = useState(false)
  const [redirect, setRedirect] = useState<string>()
  const [orderBumpOffers, setOrderBumpOffers] = useState<number[]>([])

  const handleThreeDs = useCallback(
    (threeDsData: ThreeDsInfo, bumpOffers: number[], redirect?: string) => {
      setThreeDsInfo(threeDsData)
      setRedirect(redirect)
      setOrderBumpOffers(bumpOffers)
      setIsThreeDsModalOpen(true)
    },
    [],
  )

  const handleMercadoSubmit = useCallback(
    (e: React.SyntheticEvent) => handleSubmit(e, handleThreeDs),
    [handleSubmit, handleThreeDs],
  )

  const onThreeDsClose = useCallback(
    (errors?: string[]) => {
      setIsThreeDsModalOpen(false)
      if (errors?.length) {
        setErrors?.(errors)
      }
    },
    [setErrors],
  )

  return (
    <React.Fragment>
      <TwoStepPaymentFormStepButton
        onClick={isMercadoPagoCardMethod ? handleMercadoSubmit : handleSubmit}
        disabled={isLoading || isPreview}
        color={color}
        mobileColor={mobileColor}
        backgroundColor={backgroundColor}
        mobileBackgroundColor={mobileBackgroundColor}
        text={text}
        subText={subText}
      />
      <FieldErrors errors={errors} />
      {isThreeDsModalOpen && (
        <ThreeDsModal
          creq={threeDsInfo.creq}
          external_resource_url={threeDsInfo.external_resource_url}
          redirect={redirect}
          orderBumpOffers={orderBumpOffers}
          onClose={onThreeDsClose}
        />
      )}
    </React.Fragment>
  )
}
